const languageType = [
  'ar',
  'de',
  'en',
  'es',
  'fr',
  'hi',
  'id',
  'it',
  'ja',
  'ko',
  'pt',
  'ru',
  'th',
  'tr',
  'vi',
  'zh',
  'zh-rHK',
];

function setLocalLanguage(language, languageType) {
  language = language.toLocaleLowerCase();
  if (
    language.indexOf('zh') > -1 &&
    (language.indexOf('mo') > -1 ||
      language.indexOf('tw') > -1 ||
      language.indexOf('hk') > -1 ||
      language.indexOf('hant') > -1)
  ) {
    return languageType.includes('zh-rHK') ? 'zh-rHK' : 'en';
  }

  if (
    (language.indexOf('zh') > -1 &&
      (language.indexOf('cn') > -1 || language.indexOf('ch') > -1)) ||
    language.indexOf('zh') > -1
  ) {
    return languageType.includes('zh') ? 'zh' : 'en';
  }
  let res = 'en';

  for (let i = 0; i < languageType.length; i++) {
    if (language.indexOf(languageType[i]) > -1) {
      res = languageType[i];
      break;
    }
  }
  return res;
}

function getBrowLanguage(multiple) {
  let language = '';
  try {
    if (!multiple) {
      const getLanguage = JSON.parse(sessionStorage.getItem('urlInfo'));
      language = getLanguage.language || undefined;
      if (language) return language;
    }
    if (!language) {
      throw Error('language is not available');
    }
  } catch (error) {
    language = navigator.language
      ? navigator.language
      : navigator['browserLanguage'] || navigator['userLanguage'] || 'en';
  }
  return language;
}

// 获取url 参数
function getUrlParams() {
  const data = window.location.hash || window.location.search;
  console.log('data :>> ', data);
  const getUrlInfoObj = {
    // token: '',  // 暂时也用不着token就是了
    language: '',
  };
  if (data.indexOf('?') == -1) {
    return getUrlInfoObj;
  }

  const urlInfoArr = data.split('?')[1].split('&');
  urlInfoArr.forEach((v) => {
    const [key, val] = v.split('=');
    getUrlInfoObj[key] = val == 'null' ? '' : val;
  });

  /*if (!getUrlInfoObj.token) {
    console.log('token 不存在');
  }*/
  return getUrlInfoObj;
}

export function getUrlInfo(langList) {
  const urlInfo = sessionStorage.getItem('urlInfo');
  if (urlInfo) {
    return JSON.parse(urlInfo);
  }
  const getUrlInfoObj = getUrlParams();

  if (!getUrlInfoObj.language) {
    getUrlInfoObj.language = setLocalLanguage(
      getBrowLanguage(true),
      langList || languageType
    );
  } else {
    getUrlInfoObj.language = setLocalLanguage(
      getUrlInfoObj.language,
      langList || languageType
    );
  }
  sessionStorage.setItem('urlInfo', JSON.stringify(getUrlInfoObj));
  console.log('getUrlInfoObj :>> ', getUrlInfoObj);
  return getUrlInfoObj;
}

export function getLanguage() {
  const { language } = getUrlInfo();
  return language || navigator.language || navigator.browserLanguage;
}



// WEBPACK FOOTER //
// ./src/tools/utils.js